import { render, staticRenderFns } from "./docPreview.vue?vue&type=template&id=11914d1c&scoped=true"
import script from "./docPreview.vue?vue&type=script&lang=js"
export * from "./docPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11914d1c",
  null
  
)

export default component.exports